import { mainApi } from '@/lib';
import Cookies from 'js-cookie';
import { User } from '@/types';

export async function fetchUser(): Promise<User> {
    const token = Cookies.get('token');
    if (!token) throw new Error('No authentication token found');

    const { data: user } = await mainApi.get('v1/users/me');

    return user as User;
}
